import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { Constants } from './app/common';

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: Constants.DATE_FORMAT,
  },
  display: {
    dateInput: Constants.DATE_FORMAT,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
